export const ACTION_TYPES = {
  ADD: 'Add',
  EDIT: 'Edit',
};
